import { computed, shallowRef, type Ref } from 'vue';
import { createItemMediaPlayerOpsStub, type ItemMediaPlayerOps } from './itemMediaPlayerOps';


export class ItemDetailsState {
  // Shallow: the player publishes its own observable state, and a deep ref would make `this` inside it a reactive proxy.
  private _player: Ref<ItemMediaPlayerOps> = shallowRef(createItemMediaPlayerOpsStub());

  public readonly player = computed(() => this._player.value);

  constructor() { }

  public setPlayer(itemMediaPlayerOps: ItemMediaPlayerOps) {
    this._player.value.clear();
    this._player.value = itemMediaPlayerOps;
  }
}
